export class LoadingState{
    status: "NoStatus"| "Busy" | "Success" | "Failure";

    errorDescription?: string;
}
